<template>
  <div class="dropdown">
    <button class="btn" style="padding: 0 !important;" type="button" :ref="`dropdownMenu${id}`" data-bs-toggle="dropdown" @click="dropDown.toggle()" aria-expanded="false">
      <font-awesome-icon :icon="['far', 'ellipsis-h']" color="grey" /> 
    </button>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton" >
      <li><span class="dropdown-item cpt" @click="$emit('edit', id)">{{$t('users.edit')}}</span></li>
      <li v-if="!isDisabled"><span class="dropdown-item cpt" @click="$emit('deactivate', id)">{{$t('users.schedule_deactivation')}}</span></li>
      <li v-if="isDisabled"><span class="dropdown-item cpt" @click="$emit('reactivate', id)">{{$t('users.reactivate_user')}}</span></li>
      <li><span class="dropdown-item cpt" @click="$emit('password', id)">{{$t('users.set_password_text')}}</span></li>
      <li><span class="dropdown-item cpt" @click="$emit('delete', id)">{{$t('users.delete')}}</span ></li>
    </ul>
  </div>
</template>

<script>
import { Dropdown } from "@comlinedev/bootstrap5"

export default {
  name: 'dropdownUsers',
  props:{
    id: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods:{
  },
  data(){
    return {
      dropDown: null
    }
  },
  mounted(){
    this.dropDown = new Dropdown(this.$refs[`dropdownMenu${this.id}`])
  }
}
</script>
